import getColor from "@insite/mobius/utilities/getColor";
import { footerLinkListStyles } from "@WhiteCap/Widgets/Footer/FooterLinkList";
import { css } from "styled-components";

footerLinkListStyles.footerLink = {
	css: css`
		/* 
		**** EC-97 - B2B Wesbite Footer  ****
		*** Start: Refactored dynamic CSS from CMS to code for consistent behavior across environments. */
		span[class^="TypographyStyle"] {
			text-transform: none;
			&:hover {
				color: ${getColor("primary")};;
				text-decoration: none;
            }
		}
		/* *** End: Dynamic CSS refactoring complete. Apply future updates here instead of the CMS.*/
	`
}